import { useTranslation } from "react-i18next";

import { Spinner } from "@heroui/react";
import { ButtonGradient } from "@/components/ButtonGradient";
import { useRunCalc } from "@/hooks/useRunCalc";

const R1RecalculateButton = () => {
  const { t } = useTranslation();

  const runCalcMutation = useRunCalc({ client: "r1" });
  const isSubmitting = runCalcMutation.isPending;

  const handleRecalculate = async (): Promise<void> => {
    try {
      await runCalcMutation.mutateAsync();
    } catch (err) {
      console.error("Recalculation failed", err);
    }
  };

  return (
    <ButtonGradient
      onPress={handleRecalculate}
      color="purple"
      isDisabled={isSubmitting}
      startContent={isSubmitting ? <Spinner size="sm" color="primary" /> : null}
    >
      {isSubmitting ? t("recalculate.loading") : t("recalculate.action")}
    </ButtonGradient>
  );
};

export default R1RecalculateButton;
